import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite,
    madnes_add_to_group, madnes_get_alpha,
    madnes_set_alpha,
    madnes_set_angle,
    madnes_set_img_center,
    madnes_set_pos,
    madnes_set_pos_x,
    madnes_set_scale
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_audio_loop} from "../framework/src/engine/madnes/madnes_audio";

import {
    fps,
    he,
    picture_convert,
    reels_lenghts,
    reels_pos,
    server_config,
    behavior_config,
    wi, systemConfig, wallet, commander
} from "../framework/src/engine/madnes/madnes_variables";
import {
    bet,
    madnes_fill_range, madnes_get_atomic_bet,
    madnes_get_game_specifics,
    madnes_get_json,
    madnes_set_blend_mode, madnes_set_input_down, madnes_set_input_up,
    madnes_set_win_factors
} from "../framework/src/engine/madnes/madnes";
import {cylinder_pos} from "./ninestars_config";
import {madnes_anim_add, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {stopposin, stopposin_old} from "./ninestars_core";
import {
    madnes_add_bitmap_text,
    madnes_add_text,
    madnes_set_bitmap_float
} from "../framework/src/engine/madnes/madnes_text";
import {alpha_buffer, madnes_alpha_to, madnes_move_to} from "../framework/src/engine/madnes/madnes_render";
import {ninestars_rotate_start1, ninestars_rotate_start2} from "./ninestars_anims";
import {ninestars_init_btns_phaser} from "./ninestars_btns_actions";
import {CONFIG_PARAMS, MODES} from "../framework/src/system/SystemConfig";

export let ninestars_stars_list = null;
export function set_ninestars_stars_list(list) {
    ninestars_stars_list = list;
}

export function recalc_ninestars_stars_list() {

}


// Vytvoreni potrebnych onjektu z nactenych textur.
export function ninestars_print_desk() {
    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    //behavior_config.reel.spin.timeToReachNullSpeed = 0;

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    madnes_set_win_factors(
        behavior_config.reel.minBigWinFactor,
        behavior_config.reel.minMegaWinFactor,
        behavior_config.reel.minSuperMegaWinFactor
    );

    // ninestars_set_sounds();

    // if(
    // 	typeof server_config.logic != "undefined" &&
    // 	typeof server_config.logic.bet_set != "undefined"
    // )
    // {
    // 	//bets = server_config.logic.bet_set;
    //
    // 	/*var bet0 = [];
    // 	for(var b in server_config.logic.bet_set)
    // 	{
    // 		if(
    // 			server_config.logic.bet_set[b] >= 10 &&
    // 			server_config.logic.bet_set[b] <= 100
    // 		)
    // 		{
    // 			bet0[bet0.length] = server_config.logic.bet_set[b];
    // 		}
    // 	}
    // 	bets = bet_set = bet0;*/
    //
    // 	// bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    //
    // }
    /*
    madnes_add_bitmap_text("xx1", "font_menu_mobile", 100, 60, "0123456789", 160);
    madnes_add_bitmap_text("xx2", "font_menu_mobile", 100, 260, "0123456789", 160);
    madnes_set_text("xx1", "0123456789", true);
    madnes_set_bitmap_float("xx2", "0123456789", 1, true);
    return;
    */

    madnes_add_img("reels_background", "reels_background", 0, 0);

    madnes_add_group("reels_full_plate")
    madnes_add_img("reels_full_plate_1", "reels_full_plate", wi * 0.12,	he * 0.04, 1);
    madnes_add_img("reels_full_plate_2", "reels_full_plate", wi * 0.38,	he * 0.04, 1);
    madnes_add_img("reels_full_plate_3", "reels_full_plate", wi * 0.64,	he * 0.04, 1);

    madnes_add_to_group("reels_full_plate", "reels_full_plate_1");
    madnes_add_to_group("reels_full_plate", "reels_full_plate_2");
    madnes_add_to_group("reels_full_plate", "reels_full_plate_3");

    madnes_set_pos("reels_full_plate", -9999, -9999);
    madnes_set_alpha("reels_full_plate", 0);

    ////////////////////////////////////////////////////////////////////////////////

    var style = {
        font: "26px Arial",
        fontWeight: "bold",
        fill: "#dd00cc",
        align: "left",
        boundsAlignH: "left",
        boundsAlignV: "top",
        wordWrap: false,
        wordWrapWidth: 300
    };

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        var tmp_len = server_config.logic.reels[i].length;
        for(var j = 0; j < tmp_len; j++)
        {
            //server_config.logic.reels[i][j + tmp_len] = server_config.logic.reels[i][j];
        }
    }

    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
    for(var i = 0; i < 3; i++)
    {
        for(var j in server_config.logic.reels[i])
        {
            madnes_add_sprite("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "blur", [0]);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "stop", [1]);

            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");

            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        madnes_add_sprite("reels_bufer_" + i + "_S0", picture_convert[server_config.matrix.reelMatrix[i][2]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.matrix.reelMatrix[i][1]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.matrix.reelMatrix[i][0]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);

        madnes_anim_add("reels_bufer_" + i + "_S0", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S0", "stop", [1]);
        madnes_anim_play("reels_bufer_" + i + "_S0", "stop");

        madnes_anim_add("reels_bufer_" + i + "_S1", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "stop", [1]);
        madnes_anim_play("reels_bufer_" + i + "_S1", "stop");

        madnes_anim_add("reels_bufer_" + i + "_S2", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "stop", [1]);
        madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

        madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[server_config.logic.failResult[i][2]] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);

        madnes_anim_play("reels_bufer_" + i + "_S0", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S1", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

        reels_pos[i] = 0;
    }

    madnes_add_img("background", "background", 0, 0);
    madnes_add_img("winlines", "winlines", 0, 0);




    madnes_add_img("active_winline_left_top", 		"active_winline_left_top", 		2, 16, 0);
    madnes_add_img("active_winline_left_mid_top", 	"active_winline_left_mid", 		2, 96, 0);
    madnes_add_img("active_winline_left_mid", 		"active_winline_left_mid", 		2, 280, 0);
    madnes_add_img("active_winline_left_mid_bot", 	"active_winline_left_mid", 		2, 448, 0);
    madnes_add_img("active_winline_left_bottom", 	"active_winline_left_bottom", 	2, 540, 0);

    madnes_add_img("active_winline_right_top", 		"active_winline_right_top", 		wi - 140, 16, 0);
    madnes_add_img("active_winline_right_mid_top", 	"active_winline_right_mid", 		wi - 140, 96, 0);
    madnes_add_img("active_winline_right_mid", 		"active_winline_right_mid", 		wi - 140, 280, 0);
    madnes_add_img("active_winline_right_mid_bot", 	"active_winline_right_mid", 		wi - 140, 448, 0);
    madnes_add_img("active_winline_right_bottom", 	"active_winline_right_bottom", 		wi - 140, 540, 0);

    let styleNormal = {
        "font": "28px BowlbyOne",
        "fill": "#ffffff",
        "fontWeight": "",
        "stroke": "#984343",
        "strokeThickness": 2,
        "align": "center"
    };
    madnes_add_text("winline_number_1_l",46, 300,"1", styleNormal);
    madnes_add_text("winline_number_1_r",wi-68, 300,"1", styleNormal);

    madnes_add_text("winline_number_2_l",46, 118,"2", styleNormal);
    madnes_add_text("winline_number_2_r",wi-68, 118,"2", styleNormal);

    madnes_add_text("winline_number_3_l",46, 472,"3", styleNormal);
    madnes_add_text("winline_number_3_r",wi-68, 472,"3", styleNormal);

    madnes_add_text("winline_number_4_l",46, 562,"4", styleNormal);
    madnes_add_text("winline_number_4_r",wi-68, 40,"4", styleNormal);

    madnes_add_text("winline_number_5_l",46, 40,"5", styleNormal);
    madnes_add_text("winline_number_5_r",wi-68, 562,"5", styleNormal);

    let styleActive = {
        "font": "28px BowlbyOne",
        "fill": "#00175c",
        "fontWeight": "",
        "stroke": "#00caff",
        "strokeThickness": 2,
        "align": "center"
    };
    madnes_add_text("winline_number_1_l_a",46, 300,"1", styleActive);
    madnes_add_text("winline_number_1_r_a",wi-68, 300,"1", styleActive);

    madnes_add_text("winline_number_2_l_a",46, 118,"2", styleActive);
    madnes_add_text("winline_number_2_r_a",wi-68, 118,"2", styleActive);

    madnes_add_text("winline_number_3_l_a",46, 472,"3", styleActive);
    madnes_add_text("winline_number_3_r_a",wi-68, 472,"3", styleActive);

    madnes_add_text("winline_number_4_l_a",46, 562,"4", styleActive);
    madnes_add_text("winline_number_4_r_a",wi-68, 40,"4", styleActive);

    madnes_add_text("winline_number_5_l_a",46, 40,"5", styleActive);
    madnes_add_text("winline_number_5_r_a",wi-68, 562,"5", styleActive);

    for (let XD = 1; XD <= 5; XD++) {
        madnes_set_alpha("winline_number_" + XD + "_l_a", 0);
        madnes_set_alpha("winline_number_" + XD + "_r_a", 0);
    }
    // madnes_add_img("winline_number_1_l_a", "winline_number_1_active", 46, 304, 0);
    // madnes_add_img("winline_number_1_r_a", "winline_number_1_active", wi - 68, 304, 0);
    //
    // madnes_add_img("winline_number_2_l_a", "winline_number_2_active", 42, 122, 0);
    // madnes_add_img("winline_number_2_r_a", "winline_number_2_active", wi - 72, 122, 0);
    //
    // madnes_add_img("winline_number_3_l_a", "winline_number_3_active", 42, 476, 0);
    // madnes_add_img("winline_number_3_r_a", "winline_number_3_active", wi - 72, 476, 0);
    //
    // madnes_add_img("winline_number_4_l_a", "winline_number_4_active", 40, 566, 0);
    // madnes_add_img("winline_number_4_r_a", "winline_number_4_active", wi - 74, 44, 0);
    //
    // madnes_add_img("winline_number_5_l_a", "winline_number_5_active", 42, 44, 0);
    // madnes_add_img("winline_number_5_r_a", "winline_number_5_active", wi - 72, 566, 0);

    madnes_add_img("reels-body", "reels-body", 0, 0);

    madnes_add_img("star-counter", "star-counter", wi / 2, he * 0.87, 1, 0.5, 0.5);

    madnes_add_img("star_single0", "gold-star", wi / 2 * 0.898, he * 0.818, 	0, 0.5, 0.5);
    madnes_add_img("star_single1", "gold-star", wi / 2 * 0.898, he * 0.86, 		0, 0.5, 0.5);
    madnes_add_img("star_single2", "gold-star", wi / 2 * 0.898, he * 0.903, 	0, 0.5, 0.5);

    madnes_add_img("star_single3", "gold-star", wi / 2 * 1.009, he * 0.818, 	0, 0.5, 0.5);
    madnes_add_img("star_single4", "gold-star", wi / 2 * 1.009, he * 0.86, 		0, 0.5, 0.5);
    madnes_add_img("star_single5", "gold-star", wi / 2 * 1.009, he * 0.903, 	0, 0.5, 0.5);

    madnes_add_img("star_single6", "gold-star", wi / 2 * 1.114, he * 0.818, 	0, 0.5, 0.5);
    madnes_add_img("star_single7", "gold-star", wi / 2 * 1.114, he * 0.86, 		0, 0.5, 0.5);
    madnes_add_img("star_single8", "gold-star", wi / 2 * 1.114, he * 0.903, 	0, 0.5, 0.5);

    madnes_add_img("star_single_shine0", "gold-star", wi / 2 * 0.898, he * 0.818, 	0, 0.5, 0.5);
    madnes_add_img("star_single_shine1", "gold-star", wi / 2 * 0.898, he * 0.86, 		0, 0.5, 0.5);
    madnes_add_img("star_single_shine2", "gold-star", wi / 2 * 0.898, he * 0.903, 	0, 0.5, 0.5);

    madnes_add_img("star_single_shine3", "gold-star", wi / 2 * 1.009, he * 0.818, 	0, 0.5, 0.5);
    madnes_add_img("star_single_shine4", "gold-star", wi / 2 * 1.009, he * 0.86, 		0, 0.5, 0.5);
    madnes_add_img("star_single_shine5", "gold-star", wi / 2 * 1.009, he * 0.903, 	0, 0.5, 0.5);

    madnes_add_img("star_single_shine6", "gold-star", wi / 2 * 1.114, he * 0.818, 	0, 0.5, 0.5);
    madnes_add_img("star_single_shine7", "gold-star", wi / 2 * 1.114, he * 0.86, 		0, 0.5, 0.5);
    madnes_add_img("star_single_shine8", "gold-star", wi / 2 * 1.114, he * 0.903, 	0, 0.5, 0.5);

    madnes_add_sprite("bigwin_background_sprite", "bigwin_background_sprite", -9999, -9999, 1, 0.5, 0.5);
    madnes_set_scale("bigwin_background_sprite", 2, 2);
    madnes_anim_add("bigwin_background_sprite", "stop", [0]);
    madnes_anim_add("bigwin_background_sprite", "anim", madnes_fill_range(0, 19));
    madnes_add_sprite("x2", "x2", -9999, -9999, 1, 0.5, 0.5);

    madnes_add_sprite("bigwin_x2_background_sprite", "bigwin_x2_background_sprite", -9999, -9999, 1, 0.5, 0.5);
    madnes_anim_add("bigwin_x2_background_sprite", "stop", [0]);
    madnes_anim_add("bigwin_x2_background_sprite", "anim", madnes_fill_range(0, 18));

    madnes_add_sprite("bigwin_background", "win_background", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_sprite("bigwin_text", "big_win", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_sprite("bigwin_text2", "mega_win", -9999, -9999, 1, 0.5, 0.5);
    madnes_add_sprite("bigwin_text3", "super_mega_win", -9999, -9999, 1, 0.5, 0.5);

    madnes_add_bitmap_text("bigwin_text_sum", "font_bigwin_mobile", -9999, -9999, "0", 80);
    madnes_set_img_center("bigwin_text_sum", 0.5, 0.5);

    madnes_add_sprite("bonus_background", "bonus_background", -9999, -9999);

    madnes_add_group("wheel_group");
    madnes_set_pos("wheel_group", -9999, -9999);

    madnes_set_angle("wheel_group", 1);

    madnes_add_sprite("wheel", "wheel", 0, 0);
    madnes_add_to_group("wheel_group", "wheel");
    madnes_set_img_center("wheel", 0.5, 0.5);


    var symbols_map = [];
    symbols_map["symbol_Cherry"] = "bonus_symbol_cherry";
    symbols_map["symbol_Diamond"] = "bonus_symbol_diamond";
    symbols_map["symbol_Star"] = "bonus_symbol_star";

    symbols_map["symbol_Blue7"] = "bonus_symbol_seven_blue";
    symbols_map["symbol_White7"] = "bonus_symbol_seven_yellow";
    symbols_map["symbol_Red7"] = "bonus_symbol_seven_red";

    symbols_map["symbol_BlueBar"] = "bonus_symbol_bar_blue";
    symbols_map["symbol_WhiteBar"] = "bonus_symbol_bar_yellow";
    symbols_map["symbol_RedBar"] = "bonus_symbol_bar_red";

    for(var i in server_config.logic.specifics.specialState.symbolWheel)
    {
        if(symbols_map[server_config.logic.symbols[server_config.logic.specifics.specialState.symbolWheel[i]]['name']] != null)
        {
            madnes_add_sprite("bonus_symbol_" + i, symbols_map[server_config.logic.symbols[server_config.logic.specifics.specialState.symbolWheel[i]]['name']], 0, 0);
            madnes_set_img_center("bonus_symbol_" + i, 0.5, 4.1)

            madnes_set_angle("bonus_symbol_" + i, ( 360 / server_config.logic.specifics.specialState.symbolWheel.length ) * i );

            madnes_add_to_group("wheel_group", "bonus_symbol_" + i);
        }
        else
        {
            console.log(server_config.logic.symbols[server_config.logic.specifics.specialState.symbolWheel[i]]['name']);
        }

    }

    madnes_add_group("shines");
    var pos = 0;
    for(var i = 0.00; i <= Math.PI * 0.56; i += 0.06)
    {
        var size = 570 + ( Math.random() * 20 ) ;
        var x = Math.sin(i) * size;
        var y = Math.cos(i) * size;
        madnes_add_sprite("shine_l_" + pos, "shine", -x, -y, 1, 0.5, 0.5);

        var size = 570 + ( Math.random() * 20 ) ;
        var x = Math.sin(i) * size;
        var y = Math.cos(i) * size;
        madnes_add_sprite("shine_r_" + pos, "shine",  x, -y, 1, 0.5, 0.5);

        madnes_set_blend_mode("shine_l_" + pos, PIXI.blendModes.ADD);
        madnes_set_blend_mode("shine_r_" + pos, PIXI.blendModes.ADD);

        madnes_set_alpha("shine_l_" + pos, 0);
        madnes_set_alpha("shine_r_" + pos, 0);

        madnes_add_to_group("shines", "shine_l_" + pos);
        madnes_add_to_group("shines", "shine_r_" + pos);

        var sc = Math.random() * 0.4 + 0.6;
        madnes_set_scale("shine_r_" + pos, sc, sc);
        var sc = Math.random() * 0.4 + 0.6;
        madnes_set_scale("shine_l_" + pos, sc, sc);

        pos++;
    }



    madnes_add_sprite("wheel_dark", "wheel_dark", -9999, -9999, 0, 0.5, 0.5);
    madnes_add_sprite("wheel_dark_all", "wheel_dark_all", -9999, -9999, 0, 0.5, 0.5);

    madnes_add_group("multipliers");
    madnes_add_sprite("multipliers0", "multipliers", 0, 0, 1, 0.5, 0.5);
    madnes_add_to_group("multipliers", "multipliers0");
    madnes_set_pos("multipliers", -9999, -9999);


    madnes_add_sprite("multiplier_dark", "multiplier_dark", -9999, -9999, 0);
    madnes_add_sprite("multiplier_dark_all", "multiplier_dark_all", -9999, -9999, 1);

    madnes_set_img_center("multiplier_dark", 0.5, 0.52);
    madnes_set_img_center("multiplier_dark_all", 0.5, 0.52);

    madnes_add_sprite("bonus_arrow", "bonus_arrow", -9999, -9999, 1, 0.5, 1.22);

    let spin_text = "SPIN";
    let cfg_lang = systemConfig.get(CONFIG_PARAMS.LANGUAGE);
    if (cfg_lang === "es" || cfg_lang === "es-mx") spin_text = "GIRA";

    madnes_add_group("bonus_btn_spin_disabled");
    madnes_add_sprite("bonus_btn_spin_disabled_i", "btn_spin_disabled", 0, -10, 1, 0.5, 0.5);
    madnes_add_text("bonus_btn_spin_disabled_txt", -110, -55, spin_text, {
        "font": "80px BowlbyOne",
        "fill": "darkgray",
        "fontWeight": "",
        "stroke": "#984343",
        "strokeThickness": 4,
        "align": "center"
    });
    madnes_add_to_group("bonus_btn_spin_disabled","bonus_btn_spin_disabled_i");
    madnes_add_to_group("bonus_btn_spin_disabled","bonus_btn_spin_disabled_txt");

    madnes_add_group("bonus_btn_spin");
    madnes_add_sprite("bonus_btn_spin_i", "btn_spin_basic", 0, -10, 1, 0.5, 0.5);
    madnes_add_text("bonus_btn_spin_txt", -110, -55, spin_text, {
        "font": "80px BowlbyOne",
        "fill": "#ffffff",
        "fontWeight": "",
        "stroke": "#984343",
        "strokeThickness": 4,
        "align": "center"
    });
    madnes_add_to_group("bonus_btn_spin","bonus_btn_spin_i");
    madnes_add_to_group("bonus_btn_spin","bonus_btn_spin_txt");

    madnes_add_group("bonus_btn_spin_pressed");
    madnes_add_sprite("bonus_btn_spin_pressed_i", "btn_spin_pressed", 0, -10, 1, 0.5, 0.49);
    madnes_add_text("bonus_btn_spin_pressed_txt", -110, -55, spin_text, {
        "font": "80px BowlbyOne",
        "fill": "#ffffff",
        "fontWeight": "",
        "stroke": "#984343",
        "strokeThickness": 4,
        "align": "center"
    });
    madnes_add_to_group("bonus_btn_spin_pressed","bonus_btn_spin_pressed_i");
    madnes_add_to_group("bonus_btn_spin_pressed","bonus_btn_spin_pressed_txt");

    madnes_set_pos("bonus_btn_spin_disabled", -9999, -9999);
    madnes_set_pos("bonus_btn_spin", -9999, -9999);
    madnes_set_pos("bonus_btn_spin_pressed", -9999, -9999);

    madnes_set_input_down("bonus_btn_spin_pressed_i", ninestars_rotate_start1);
    madnes_set_input_up("bonus_btn_spin_pressed_i", ninestars_rotate_start2);

    madnes_add_sprite("arrows", "arrows", -9999, -9999, 1, 0.5, 2.4);

    madnes_add_group("shines2");
    var pos = 0;
    for(var i = 0.00; i <= Math.PI * 0.56; i += 0.12)
    {
        var size = 270 + ( Math.random() * 20 ) ;
        var x = Math.sin(i) * size;
        var y = Math.cos(i) * size;
        madnes_add_sprite("shine_l2_" + pos, "shine", -x, -y, 1, 0.5, 0.5);

        var size = 570 + ( Math.random() * 20 ) ;
        var x = Math.sin(i) * size;
        var y = Math.cos(i) * size;
        madnes_add_sprite("shine_r2_" + pos, "shine",  x, -y, 1, 0.5, 0.5);

        madnes_set_blend_mode("shine_l2_" + pos, PIXI.blendModes.ADD);
        madnes_set_blend_mode("shine_r2_" + pos, PIXI.blendModes.ADD);

        madnes_set_alpha("shine_l2_" + pos, 0);
        madnes_set_alpha("shine_r2_" + pos, 0);

        madnes_add_to_group("shines2", "shine_l2_" + pos);
        madnes_add_to_group("shines2", "shine_r2_" + pos);

        var sc = Math.random() * 0.4 + 0.6;
        madnes_set_scale("shine_r2_" + pos, sc, sc);
        var sc = Math.random() * 0.4 + 0.6;
        madnes_set_scale("shine_l2_" + pos, sc, sc);

        pos++;
    }

    /*
    setTimeout(function() {

        var top = 0.87;

        madnes_set_pos("bonus_background", 0, 0);
        madnes_set_alpha("bonus_background", 0);
        madnes_alpha_to("bonus_background", 1, 1000);

        //madnes_set_pos("bonus_sparkle", 0, 0);
        //madnes_set_alpha("bonus_sparkle", 0);
        //madnes_alpha_to("bonus_sparkle", 1, 0.6);

        //madnes_set_pos("bonus_body", wi / 2, 0);
        //madnes_set_alpha("bonus_body", 0);
        //madnes_alpha_to("bonus_body", 1, 0.6);


        madnes_set_pos("wheel_group", wi / 2, ( he * top ) + 1000);
        madnes_move_to("wheel_group", wi / 2, he * top, 1000);

        madnes_set_pos("shines", wi / 2, ( he * top ) + 1000);
        madnes_move_to("shines", wi / 2, he * top, 1000);

        madnes_set_pos("shines2", wi / 2, ( he * top ) + 1000);
        madnes_move_to("shines2", wi / 2, he * top, 1000);

        madnes_set_pos("wheel_dark", wi / 2, ( he * top ) + 1000);
        madnes_move_to("wheel_dark", wi / 2, he * top, 1000);

        madnes_set_pos("wheel_dark_all", wi / 2, ( he * top ) + 1000);
        madnes_move_to("wheel_dark_all", wi / 2, he * top, 1000);

        madnes_set_pos("multipliers", wi / 2, ( he * top ) + 1000);
        madnes_move_to("multipliers", wi / 2, he * top, 1000);

        madnes_set_pos("multiplier_dark", wi / 2, ( he * top ) + 1000);
        madnes_move_to("multiplier_dark", wi / 2, he * top, 1000);

        madnes_set_pos("multiplier_dark_all", wi / 2, ( he * top ) + 1000);
        madnes_move_to("multiplier_dark_all", wi / 2, he * top, 1000);

        madnes_set_pos("bonus_arrow", wi / 2, ( he * top ) + 1000);
        madnes_move_to("bonus_arrow", wi / 2, he * top, 1000);

        madnes_set_pos("bonus_btn_spin_disabled", wi / 2, ( he * top ) + 1000);
        madnes_move_to("bonus_btn_spin_disabled", wi / 2, he * top, 1000);

        madnes_set_pos("bonus_btn_spin", wi / 2, ( he * top ) + 1000);
        madnes_move_to("bonus_btn_spin", wi / 2, he * top, 1000);

        madnes_set_pos("bonus_btn_spin_pressed", wi / 2, ( he * top ) + 1000);
        madnes_move_to("bonus_btn_spin_pressed", wi / 2, he * top, 1000);

        madnes_set_pos("arrows", wi / 2, he * top);
        madnes_set_alpha("arrows", 0);
        madnes_alpha_to("arrows", 1, 1000);

        //madnes_rotate_to("wheel_group", 360 * 2, 1, 4000);
        //madnes_rotate_to("multipliers", 360 * 8, -1, 4000);


        madnes_set_angle("wheel_group", 0);
        madnes_tween_to("wheel_group", {angle: 360 * 2}, 4000, "cubic_out");


        //ninestars_reel_shines_en = 1;
        //ninestars_reel_shines();

        //ninestars_reel_shines2_en = 1;
        //ninestars_reel_shines2();
    }, 1000);


    */

    ninestars_stars_list = madnes_get_game_specifics().specialState.permanentSymbols;

    // console.log("#1", "setting list", server_config.logic.specifics.specialState.permanentSymbols);

    // madnes_resize();

    ninestars_init_btns_phaser();

    madnes_audio_loop("background");
}


export let ninestars_reel_shines_en = 0;
export function set_ninestars_reel_shines_en(val) {
    ninestars_reel_shines_en = val;
}

var ninestars_reel_shines_dir = 0;
export function ninestars_reel_shines()
{
    if(ninestars_reel_shines_en == 0)
    {
        return;
    }

    var pos = 0;

    var fr = 0.00;
    var to = Math.PI * 0.56;
    var ad = 0.06;

    if(ninestars_reel_shines_dir == 1)
    {
        fr = Math.PI * 0.56;
        to = 0.00;
        ad = -0.06;
    }

    for(
        var i = fr;
        (
            i <= to &&
            ninestars_reel_shines_dir == 0
        )
        ||
        (
            i >= to &&
            ninestars_reel_shines_dir == 1
        );
        i += ad
    )
    {
        setTimeout(function(i, pos)
        {
            var size = 570 + ( Math.random() * 20 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_set_pos("shine_l_" + pos, -x, -y);

            var size = 570 + ( Math.random() * 20 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_set_pos("shine_r_" + pos, x, -y);

            var size = 590 + ( Math.random() * 40 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_move_to("shine_l_" + pos, -x, -y, 1000);

            var size = 590 + ( Math.random() * 40 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_move_to("shine_r_" + pos, x, -y, 1000);

            madnes_alpha_to(
                "shine_l_" + pos,
                Math.random() * 0.6 + 0.4,
                Math.random() * 200 + 400,
                function(i, pos)
                {
                    setTimeout(
                        madnes_alpha_to.bind(this, "shine_l_" + pos, 0, Math.random() * 200 + 400)
                        , Math.random() * 200
                    )
                }.bind(this, i, pos)
            );

            madnes_alpha_to(
                "shine_r_" + pos,
                Math.random() * 0.6 + 0.4,
                Math.random() * 200 + 400,
                function(i, pos)
                {
                    setTimeout(
                        madnes_alpha_to.bind(this, "shine_r_" + pos, 0, Math.random() * 200 + 400)
                        , Math.random() * 200
                    )
                }.bind(this, i, pos)
            );

        }.bind(this, i, pos), 20 * pos);
        pos++;
    }

    if(ninestars_reel_shines_dir == 1)
    {
        ninestars_reel_shines_dir = 0;
    }
    else
    {
        ninestars_reel_shines_dir = 1;
    }

    setTimeout(ninestars_reel_shines, 20 * pos + 800);
}

export let ninestars_reel_shines2_en = 0;
export function set_ninestars_reel_shines2_en(val) {
    ninestars_reel_shines2_en = val;
}


var ninestars_reel_shines2_dir = 0;
export function ninestars_reel_shines2()
{
    if(ninestars_reel_shines2_en == 0)
    {
        return;
    }

    var pos = 0;

    var fr = 0.00;
    var to = Math.PI * 0.56;
    var ad = 0.12;

    if(ninestars_reel_shines2_dir == 1)
    {
        fr = Math.PI * 0.56;
        to = 0.00;
        ad = -0.12;
    }

    for(
        var i = fr;
        (
            i <= to &&
            ninestars_reel_shines2_dir == 0
        )
        ||
        (
            i >= to &&
            ninestars_reel_shines2_dir == 1
        );
        i += ad
    )
    {
        setTimeout(function(i, pos)
        {
            var size = 20 + 270 + ( Math.random() * 20 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_set_pos("shine_l2_" + pos, -x, -y);

            var size = 20 + 270 + ( Math.random() * 20 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_set_pos("shine_r2_" + pos, x, -y);

            var size = 20 + 290 + ( Math.random() * 40 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_move_to("shine_l2_" + pos, -x, -y, 1000);

            var size = 20 + 290 + ( Math.random() * 40 ) ;
            var x = Math.sin(i) * size;
            var y = Math.cos(i) * size;
            madnes_move_to("shine_r2_" + pos, x, -y, 1000);

            madnes_alpha_to(
                "shine_l2_" + pos,
                Math.random() * 0.6 + 0.4,
                Math.random() * 200 + 400,
                function(i, pos)
                {
                    setTimeout(
                        madnes_alpha_to.bind(this, "shine_l2_" + pos, 0, Math.random() * 200 + 400)
                        , Math.random() * 200
                    )
                }.bind(this, i, pos)
            );

            madnes_alpha_to(
                "shine_r2_" + pos,
                Math.random() * 0.6 + 0.4,
                Math.random() * 200 + 400,
                function(i, pos)
                {
                    setTimeout(
                        madnes_alpha_to.bind(this, "shine_r2_" + pos, 0, Math.random() * 200 + 400)
                        , Math.random() * 200
                    )
                }.bind(this, i, pos)
            );

        }.bind(this, i, pos), 20 * pos);
        pos++;
    }

    if(ninestars_reel_shines2_dir == 1)
    {
        ninestars_reel_shines2_dir = 0;
    }
    else
    {
        ninestars_reel_shines2_dir = 1;
    }

    setTimeout(ninestars_reel_shines2, 20 * pos + 800);
}

export let openinfo = false;

var settings_background_pos;
export function ninestars_infomenu_init()
{

    settings_background_pos = 1;
    madnes_add_img("settings_background_1", "settings_background_1", -9999, -9999);
    madnes_add_img("settings_background_2", "settings_background_2", -9999, -9999);
    madnes_add_img("settings_background_3", "settings_background_3", -9999, -9999);

    madnes_add_group("settings_group_1");
    madnes_add_group("settings_group_2");
    madnes_add_group("settings_group_3");

    if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
        madnes_add_img("info_btn_spin", "btn_spin_basic_es", 212, 545);
        madnes_set_scale("info_btn_spin", .18, .18);
        madnes_add_to_group("settings_group_2", "info_btn_spin");
    }

    var start_x = 210;
    var start_y = 580;

    var wi_dif = 214;

    let numStyle =  {
        "font": "32px BowlbyOne",
        "fill": "#ffe94b ",
        "fontWeight": "",
        "stroke": "#051066",
        "strokeThickness": 4,
        "align": "center"
    };
    madnes_add_text("star", start_x + wi_dif * 0, start_y, "0",numStyle);
    madnes_add_text("daim", start_x + wi_dif * 1, start_y, "0",numStyle);
    madnes_add_text("seve", start_x + wi_dif * 2, start_y, "0",numStyle);
    madnes_add_text("bars", start_x + wi_dif * 3, start_y, "0",numStyle);
    madnes_add_text("cher", start_x + wi_dif * 4, start_y, "0",numStyle);
    // madnes_add_bitmap_text("star", "font_menu_mobile", start_x + wi_dif * 0, start_y, "0", 80);
    // madnes_add_bitmap_text("daim", "font_menu_mobile", start_x + wi_dif * 1, start_y, "0", 80);
    // madnes_add_bitmap_text("seve", "font_menu_mobile", start_x + wi_dif * 2, start_y, "0", 80);
    // madnes_add_bitmap_text("bars", "font_menu_mobile", start_x + wi_dif * 3, start_y, "0", 80);
    // madnes_add_bitmap_text("cher", "font_menu_mobile", start_x + wi_dif * 4, start_y, "0", 80);

    madnes_set_img_center("star", 0.5, 0.5);
    madnes_set_img_center("daim", 0.5, 0.5);
    madnes_set_img_center("seve", 0.5, 0.5);
    madnes_set_img_center("bars", 0.5, 0.5);
    madnes_set_img_center("cher", 0.5, 0.5);

    madnes_add_to_group("settings_group_1", "star");
    madnes_add_to_group("settings_group_1", "daim");
    madnes_add_to_group("settings_group_1", "seve");
    madnes_add_to_group("settings_group_1", "bars");
    madnes_add_to_group("settings_group_1", "cher");

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        var x = infotext[i].position[0];
        var y = infotext[i].position[1];
        var page = infotext[i].page;
        var lineHeight0 = infotext[i].lineHeight;
        var lineHeight1 = infotext[i].lineHeight;
        var x_add = 0;
        var center = 0;

        if(infotext[i].center && infotext[i].center == 1)
        {
            center = 1;
        }

        var style0 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
            "strokeThickness": 0
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i].fontSize && infotext[i].font)
        {
            style0.font = infotext[i].fontSize + "px " + infotext[i].font;
            style1.font = infotext[i].fontSize + "px " + infotext[i].font;
        }
        if(infotext[i].color)
        {
            style0.fill = infotext[i].color;
            style1.fill = infotext[i].color;
        }
        if(infotext[i].bold)
        {
            if(infotext[i].bold == 1)
            {
                style0.fontWeight = "bold";
                style1.fontWeight = "bold";
            }
            else if(infotext[i].bold == 1)
            {
                style0.fontWeight = "";
                style1.fontWeight = "";
            }
        }

        if(infotext[i].title.fontSize && infotext[i].title.font)
        {
            style0.font = infotext[i].title.fontSize + "px " + infotext[i].title.font;
        }
        if(infotext[i].title.lineHeight)
        {
            lineHeight0 = infotext[i].title.lineHeight;
        }
        if(infotext[i].title.color)
        {
            style0.fill = infotext[i].title.color;
        }
        if(infotext[i].title.strokeThickness)
        {
            style0.strokeThickness = infotext[i].title.strokeThickness;
        }
        if(infotext[i].title.bold)
        {
            if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "bold";
            }
            else if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "";
            }
        }

        if(infotext[i].body.fontSize && infotext[i].body.font)
        {
            style1.font = infotext[i].body.fontSize + "px " + infotext[i].body.font;
        }
        if(infotext[i].body.color)
        {
            style1.fill = infotext[i].body.color;
        }
        if(infotext[i].body.lineHeight)
        {
            lineHeight1 = infotext[i].body.lineHeight;
        }
        if(infotext[i].body.bold)
        {
            if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "bold";
            }
            else if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "";
            }
        }
        if(infotext[i].body.x_add)
        {
            x_add = infotext[i].body.x_add;
        }

        var line0 = 0;
        var line1 = 0;

        for(var j in infotext[i].title.content)
        {
            var text = infotext[i].title.content[j];
            madnes_add_text("info_header_" + i + "_"  + j + "_" + line0, x, y + line0 * lineHeight0, text, style0);
            if(center == 1)
            {
                madnes_set_img_center("info_header_" + i + "_"  + j + "_" + line0, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_header_" + i + "_"  + j + "_" + line0);
            line0++;
        }

        for(var j in infotext[i].body.content)
        {
            var text = infotext[i].body.content[j];
            madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x * 1 + x_add * 1, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
            if(center == 1)
            {
                madnes_set_img_center("info_body_" + i + "_"  + j + "_" + line1, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_body_" + i + "_"  + j + "_" + line1);
            line1++;
        }

    }
    ninestars_clear_stars();

    ninestars_infomenu_update();

    ninestars_infomenu_close();
}

export function ninestars_infomenu_open()
{
    settings_background_pos = 1;

    madnes_set_pos("settings_background_1", 0   , 0);
    madnes_set_pos("settings_background_2", 2500, 0);
    madnes_set_pos("settings_background_3", 2500, 0);

    madnes_set_pos("settings_group_1", 0, 0);
    madnes_set_pos("settings_group_2", 2500, 0);
    madnes_set_pos("settings_group_3", 2500, 0);

    openinfo = true;
}

export function ninestars_infomenu_close()
{
    madnes_set_pos("settings_background_1", -9999, -9999);
    madnes_set_pos("settings_background_2", -9999, -9999);
    madnes_set_pos("settings_background_3", -9999, -9999);

    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);

    openinfo = false;
}

export function ninestars_infomenu_update()
{
    if (commander.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) return
    // var set0 = ninestars_stars_list[server_config.logic.bet_set.indexOf(madnes_get_money_bet(bet))];

    let atomBet = madnes_get_atomic_bet(bet);
    let betIndex = wallet.getBetSet().indexOf(atomBet);

    var set0 = madnes_get_game_specifics().specialState.permanentSymbols[betIndex];

    // console.log("#2", "setting set0", ninestars_stars_list[betIndex], betIndex, atomBet);
    for(var i in set0)
    {
        if(madnes_get_alpha("star_single" + i) != set0[i] && systemConfig.get(CONFIG_PARAMS.MODE) !== MODES.REPLAY)
        {
            //madnes_alpha_to("star_single" + i, set0[i], 800);
            if(set0[i] == 1)
            {
                alpha_buffer.forEach((a)=>{
                    if (a.key == "star_single"+i) {
                        alpha_buffer.splice(alpha_buffer.indexOf(a), 1);
                    }
                });
                //madnes_rotate_to("star_single" + i, 360, 1, 800, madnes_set_angle.bind(true, "star_single" + i, 0));
                madnes_alpha_to("star_single" + i, set0[i], 400);

                madnes_set_blend_mode("star_single_shine" + i, PIXI.blendModes.ADD);
                setTimeout(
                    madnes_alpha_to.bind(this, "star_single_shine" + i, 1, 200)
                    , 400);

                setTimeout(
                    madnes_alpha_to.bind(this, "star_single_shine" + i, 0, 200)
                    , 600);


            }
            else
            {
                alpha_buffer.forEach((a)=>{
                    if (a.key == "star_single"+i) {
                        alpha_buffer.splice(alpha_buffer.indexOf(a), 1);
                    }
                });
                //madnes_rotate_to("star_single" + i, 360, -1, 800, madnes_set_angle.bind(true, "star_single" + i, 0));
                madnes_alpha_to("star_single" + i, set0[i], 800);
            }
        }
    }

    var max_wi = 134;
    madnes_set_bitmap_float("star", server_config.logic.symbols[8].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("daim", server_config.logic.symbols[7].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("seve", server_config.logic.symbols[4].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("bars", server_config.logic.symbols[1].factors[2] * bet, max_wi);
    madnes_set_bitmap_float("cher", server_config.logic.symbols[0].factors[2] * bet, max_wi);

    //}, 2000);
}

export function ninestars_clear_stars() {
    if (commander.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) return
    var set0 = ninestars_stars_list[wallet.getBetIndex()];

    for(var i in set0) {
        if (madnes_get_alpha("star_single" + i) != set0[i]) {
            //madnes_alpha_to("star_single" + i, set0[i], 800);
            if (set0[i] == 1) {
                alpha_buffer.forEach((a) => {
                    if (a.key == "star_single" + i) {
                        alpha_buffer.splice(alpha_buffer.indexOf(a), 1);
                    }
                });
                madnes_set_alpha("star_single" + i, 1);
            } else {
                alpha_buffer.forEach((a) => {
                    if (a.key == "star_single" + i) {
                        alpha_buffer.splice(alpha_buffer.indexOf(a), 1);
                    }
                });
                madnes_set_alpha("star_single" + i, 0);
            }
        }
    }
}

export function ninestars_infomenu_left()
{
    if(!openinfo) return;
    if(ninestars_infomenu_move_in == 0)
    {
        ninestars_infomenu_move_in = 1;
        ninestars_infomenu_move_dir = -1;
        ninestars_infomenu_move_pos = 0;
        ninestars_infomenu_move();
    }
}

export function ninestars_infomenu_right()
{
    if(!openinfo) return;
    if(ninestars_infomenu_move_in == 0)
    {
        ninestars_infomenu_move_in = 1;
        ninestars_infomenu_move_dir = 1;
        ninestars_infomenu_move_pos = 0;
        ninestars_infomenu_move();
    }
}

var ninestars_infomenu_move_in = 0;
var ninestars_infomenu_move_dir = 0;
var ninestars_infomenu_move_pos = 0;
var ninestars_infomenu_move_speed = 160;
var settings_background_pos2;

function ninestars_infomenu_move()
{
    //ninestars_infomenu_move_speed = wi;

    settings_background_pos2 = settings_background_pos * 1 + ninestars_infomenu_move_dir;
    if(settings_background_pos2 > 3)
    {
        settings_background_pos2 = 1;
    }
    if(settings_background_pos2 < 1)
    {
        settings_background_pos2 = 3;
    }

    ninestars_infomenu_move_pos = ninestars_infomenu_move_pos * 1 + ninestars_infomenu_move_dir * ninestars_infomenu_move_speed * -1;

    madnes_set_pos_x("settings_background_" + settings_background_pos, ninestars_infomenu_move_pos, 0);
    madnes_set_pos_x("settings_background_" + settings_background_pos2, ninestars_infomenu_move_pos + wi * ninestars_infomenu_move_dir * 1, 0);

    madnes_set_pos_x("settings_group_" + settings_background_pos, ninestars_infomenu_move_pos, 0);
    madnes_set_pos_x("settings_group_" + settings_background_pos2, ninestars_infomenu_move_pos + wi * ninestars_infomenu_move_dir * 1, 0);

    if(Math.abs(ninestars_infomenu_move_pos) < wi)
    {
        setTimeout(ninestars_infomenu_move,1000 / fps);
    }
    else
    {
        madnes_set_pos_x("settings_background_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_background_" + settings_background_pos, 2500, 0);

        madnes_set_pos_x("settings_group_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_group_" + settings_background_pos, 2500, 0);

        settings_background_pos = settings_background_pos2;
        ninestars_infomenu_move_in = 0;
        ninestars_infomenu_move_dir = 0;
        ninestars_infomenu_move_pos = 0;
    }
}


// Render pro kourovy efekt
function ninestars_render_phaser()
{
    if(in_smoke_pos++%3==0 && smoke_emitter != null)
    {
        for(var i = 0; i < 5; i++)
        {
            if(freespin_state != null && freespin_state[i] != null && freespin_state[i] == 1)
            {
                if(madnes_check_focus())
                {
                    var xpos = null;
                    switch(i){
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4: xpos = [(cylinder_pos[i]+25)*wi_scale,(cylinder_pos[i]-25+ico_wi)*wi_scale]; break;
                        default: xpos = [-9999, -9999];
                            break;
                    }
                    var rep = 5;
                    var freq = 30;
                    smoke_emitter[i].emit('smoke', xpos, he*he_scale*0.85, { repeat: rep, frequency: freq });
                }
            }
        }
    }
}
